// import { createRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router";
// import "./index.css";
// import App from "./App.tsx";
// import { Provider } from "react-redux";
// import { store } from "./api/store.ts";
// createRoot(document.getElementById("root")!).render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </Provider>
// );

// import { createRoot } from "react-dom/client";
// import { BrowserRouter, useLocation } from "react-router-dom";
// import "./index.css";
// import App from "./App.tsx";
// import { Provider } from "react-redux";
// import { store } from "./api/store.ts";
// import { HelmetProvider } from "react-helmet-async";

// import ReactGA from "react-ga4";

//  const location = useLocation();

// const TRACKING_ID = "G-W9TS45ZX4W";
// ReactGA.initialize(TRACKING_ID);
// ReactGA.send({ hitType: "pageview", page: location.pathname, title: "Ceylon Hospital Home Page" });

// createRoot(document.getElementById("root")!).render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <HelmetProvider>
//         <App />
//       </HelmetProvider>
//     </BrowserRouter>
//   </Provider>
// );

//Correct///////////////////////////////////////////////////////////////////////////////////////////



// import { createRoot } from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import "./index.css";
// import App from "./App.tsx";
// import { Provider } from "react-redux";
// import { store } from "./api/store.ts";
// import { HelmetProvider } from "react-helmet-async";
// import ReactGA from "react-ga4";

// const TRACKING_ID = "G-W9TS45ZX4W";
// ReactGA.initialize(TRACKING_ID);

// createRoot(document.getElementById("root")!).render(
//   <Provider store={store}>
//     <BrowserRouter>
//       <HelmetProvider>
//         <App />
//       </HelmetProvider>
//     </BrowserRouter>
//   </Provider>
// );

// Duplicate////////////////////////////////////////////////////////////////////////////////////

import "./App.css"
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.tsx";
import { Provider } from "react-redux";
import { store } from "./api/store.ts";
import { HelmetProvider } from "react-helmet-async";
import ReactGA from "react-ga4";
const TRACKING_ID = "G-W9TS45ZX4W";
ReactGA.initialize(TRACKING_ID);

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <BrowserRouter>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </BrowserRouter>
  </Provider>
);